import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import MenuItem from "material-ui/MenuItem";
import { VIEWPORT_PHABLET, VIEWPORT_MOBILE, VIEWPORT_TABLET } from "constants/media";
import { ItemViewType } from "constants/types";
import { getDefaultView } from "components/items/items-utils";
import theme from "styles/theme";

const mStyle = {
    iconButton: {
        padding: "6px",
        width: "42px",
        height: "42px",
        marginTop: "2px",
        marginLeft: "-4px",
    },
    svgIcon: {
        height: 24,
        width: 24,
    },
};

const defaultOptionIndex = Object.values(ItemViewType).indexOf(getDefaultView());

export class ViewPicker extends PureComponent {
    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        viewport: PropTypes.string.isRequired,
        choices: PropTypes.array.isRequired,
    };

    static defaultProps = {
        viewNotes: false,
    };

    UNSAFE_componentWillMount() {
        if ([VIEWPORT_PHABLET, VIEWPORT_MOBILE].includes(this.props.viewport) && this.props.value === "list") {
            this.props.onChange(this.props.choices[defaultOptionIndex][0]);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.viewport !== this.props.viewport &&
            [VIEWPORT_PHABLET, VIEWPORT_MOBILE].includes(nextProps.viewport) &&
            nextProps.value === "list"
        ) {
            nextProps.onChange(nextProps.choices[defaultOptionIndex][0]);
        }
    }

    handleViewChange(e, view) {
        this.props.onChange(view);
    }

    render() {
        const { value, viewport, choices } = this.props;

        if ([VIEWPORT_PHABLET, VIEWPORT_MOBILE, VIEWPORT_TABLET].includes(viewport)) {
            let Icon = null;
            let options = choices;
            if (viewport !== VIEWPORT_TABLET) {
                options = options.filter((choice) => choice[0] !== "list");
            }
            options = options.map((choice) => {
                if (value === choice[0]) {
                    Icon = choice[2];
                }
                const SubIcon = choice[2];
                return <MenuItem key={choice[0]} value={choice[0]} primaryText={choice[1]} leftIcon={<SubIcon />} />;
            });
            if (!Icon) {
                Icon = choices[defaultOptionIndex][2];
            }
            return (
                <IconMenu
                    iconButtonElement={
                        <IconButton>
                            <Icon />
                        </IconButton>
                    }
                    onChange={this.handleViewChange.bind(this)}
                    value={value}
                    style={{ top: "-4px" }}
                >
                    {options}
                </IconMenu>
            );
        }

        const options = choices.map((choice) => {
            const Icon = choice[2];
            return (
                <IconButton
                    key={choice[0]}
                    onClick={this.handleViewChange.bind(this, null, choice[0])}
                    style={mStyle.iconButton}
                    data-test={`${choice[0]}-view`}
                    iconStyle={mStyle.svgIcon}
                >
                    <Icon htmlColor={value === choice[0] ? theme.palette.darkGrey : theme.palette.grey} />
                </IconButton>
            );
        });
        return <div style={{ whiteSpace: "nowrap" }}>{options}</div>;
    }
}

export default ViewPicker;
